import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';

import { pageKey } from '@dashboard/lib/queryKeys';

const PAGE_PATH = /^\/pages\/([^/]+)(\/.*)?$/;

/**
 * Jumping from one page to another of the same type lands on the screen already open, so a
 * seller comparing Details across pages stays on Details. Other types have different screens.
 */
export function usePageScreenPath() {
  const { pathname } = useLocation();
  const queryClient = useQueryClient();

  return useCallback(
    (path: string, pageType?: string) => {
      const target = path.match(PAGE_PATH);
      const current = pathname.match(PAGE_PATH);
      if (!target || !current?.[2] || target[1] === current[1] || !pageType) return path;
      const currentPage = queryClient.getQueryData<{ type?: string }>(pageKey(current[1]));
      if (currentPage?.type !== pageType) return path;
      return `/pages/${target[1]}${current[2]}`;
    },
    [pathname, queryClient],
  );
}
